import {
  useNavigate
} from "react-router-dom";

import PaymentTable from "../components/PaymentTable";
import PaymentFilters from "../components/PaymentFilters";

import {
  usePayments
} from "../hooks/usePayments";

const PaymentsPage = () => {
  const navigate =
    useNavigate();

  const {
    payments,
    filters,
    updateFilters,
    resetFilters,
    loading,
    error
  } = usePayments();


  const handleView = (
    id
  ) => {
    navigate(
      `/payments/${id}`
    );
  };


  return (
    <div className="payments-page">
      <div className="payments-page__header">
        <div>
          <span className="payments-page__label">
            Dashboard
          </span>

          <h1>
            Payments
          </h1>

          <p>
            Manage and monitor
            customer payments.
          </p>
        </div>
      </div>

      <PaymentFilters
        filters={filters}
        onFilterChange={
          updateFilters
        }
        onReset={
          resetFilters
        }
      />

      {loading && (
        <div className="payments-page__loading">
          Loading payments...
        </div>
      )}

      {error && (
        <div className="payments-page__error">
          Failed to load payments.
        </div>
      )}

      {!loading && (
        <PaymentTable
          payments={payments}
          onView={handleView}
        />
      )}
    </div>
  );
};

export default PaymentsPage;
